// All SVG icons for the GEK toolbar are located here and exported at the bottom
// All of these icons are then used in the button components in ./ToolbarButtons.tsx

interface SvgIconProps {
  className?: string;
  color?: string;
  strokeWidth?: string;
}

const PolygonIcon = ({ className, color, strokeWidth }: SvgIconProps) => {
  return (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        strokeWidth={0.25}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 1.5C4.17157 1.5 3.5 2.17157 3.5 3C3.5 3.82843 4.17157 4.5 5 4.5C5.82843 4.5 6.5 3.82843 6.5 3C6.5 2.17157 5.82843 1.5 5 1.5ZM2.5 3C2.5 1.61929 3.61929 0.5 5 0.5C6.37213 0.5 7.48608 1.60542 7.49987 2.97429L9.63729 3.18084C9.97646 2.20245 10.9062 1.5 12 1.5C13.3807 1.5 14.5 2.61929 14.5 4C14.5 5.38071 13.3807 6.5 12 6.5C11.9429 6.5 11.8862 6.49808 11.83 6.49431L11.3674 8.7629C12.1872 9.17314 12.7502 10.0208 12.7502 11C12.7502 12.3807 11.6309 13.5 10.2502 13.5C8.8877 13.5 7.77979 12.4101 7.75075 11.0546L5.1513 10.2743C4.71569 11.0081 3.91529 11.5 3 11.5C1.61929 11.5 0.5 10.3807 0.5 9C0.5 7.61929 1.61929 6.5 3 6.5C3.03519 6.5 3.0702 6.50073 3.10504 6.50217L3.70006 5.13588C2.98044 4.69696 2.5 3.90459 2.5 3ZM7.93102 10.0646C8.30136 9.14731 9.20017 8.5 10.2502 8.5C10.3003 8.5 10.3501 8.50148 10.3995 8.50439L10.8638 6.2275C10.1026 5.83847 9.56718 5.07075 9.50588 4.1728L7.30884 3.96048C6.93234 4.86449 6.04039 5.5 5 5.5C4.87886 5.5 4.75974 5.49138 4.64321 5.47473L4.08838 6.74871C4.92386 7.15337 5.5 8.0094 5.5 9C5.5 9.11134 5.49272 9.22098 5.47861 9.32847L7.93102 10.0646ZM1.5 9C1.5 8.17157 2.17157 7.5 3 7.5C3.82843 7.5 4.5 8.17157 4.5 9C4.5 9.82843 3.82843 10.5 3 10.5C2.17157 10.5 1.5 9.82843 1.5 9ZM12 2.5C11.1716 2.5 10.5 3.17157 10.5 4C10.5 4.82843 11.1716 5.5 12 5.5C12.8284 5.5 13.5 4.82843 13.5 4C13.5 3.17157 12.8284 2.5 12 2.5ZM8.75016 11C8.75016 10.1716 9.42174 9.5 10.2502 9.5C11.0786 9.5 11.7502 10.1716 11.7502 11C11.7502 11.8284 11.0786 12.5 10.2502 12.5C9.42174 12.5 8.75016 11.8284 8.75016 11Z"
        fill="black"
      />
    </svg>
  );
};

const LineIcon = ({ className, color, strokeWidth }: SvgIconProps) => {
  return (
    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 3C1.5 2.17157 2.17157 1.5 3 1.5C3.82843 1.5 4.5 2.17157 4.5 3C4.5 3.82843 3.82843 4.5 3 4.5C2.17157 4.5 1.5 3.82843 1.5 3ZM3 0.5C1.61929 0.5 0.5 1.61929 0.5 3C0.5 4.20889 1.35805 5.21738 2.49834 5.44965L2.78486 8.23991C1.75263 8.54753 1 9.50394 1 10.6361C1 12.0168 2.11929 13.1361 3.5 13.1361C4.88071 13.1361 6 12.0168 6 10.6361C6 9.35044 5.02947 8.29143 3.78107 8.15176L3.50356 5.44927C4.32198 5.28189 4.99476 4.71461 5.30884 3.96048L7.50588 4.1728C7.59463 5.4729 8.67737 6.5 10 6.5C11.3807 6.5 12.5 5.38071 12.5 4C12.5 2.61929 11.3807 1.5 10 1.5C8.9062 1.5 7.97646 2.20245 7.63729 3.18084L5.49987 2.97429C5.48608 1.60542 4.37213 0.5 3 0.5ZM3.5 9.13613C2.67157 9.13613 2 9.8077 2 10.6361C2 11.4646 2.67157 12.1361 3.5 12.1361C4.32843 12.1361 5 11.4646 5 10.6361C5 9.8077 4.32843 9.13613 3.5 9.13613ZM8.5 4C8.5 3.17157 9.17157 2.5 10 2.5C10.8284 2.5 11.5 3.17157 11.5 4C11.5 4.82843 10.8284 5.5 10 5.5C9.17157 5.5 8.5 4.82843 8.5 4Z"
        fill="black"
      />
    </svg>
  );
};

const CircleIcon = (_: SvgIconProps) => {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <circle cx="7.5" cy="7" r="6.5" strokeWidth="1" stroke="black" fill="" />
    </svg>
  );
};

// Additional typing for the Marker and Cancel Icons
interface SvgIconPropsStroke extends SvgIconProps {
  stroke?: string;
}

const MarkerIcon = ({ className, stroke, color, strokeWidth }: SvgIconPropsStroke) => {
  return (
    <svg
      width="5"
      height="13"
      viewBox="0 0 5 13"
      fill="none"
      className={className}
      strokeWidth={strokeWidth || '1'}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        stroke={stroke || color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 2.5C1 1.67157 1.67157 1 2.5 1C3.32843 1 4 1.67157 4 2.5C4 3.32843 3.32843 4 2.5 4C1.67157 4 1 3.32843 1 2.5ZM3 4.94999C4.14112 4.71836 5 3.70948 5 2.5C5 1.11929 3.88071 0 2.5 0C1.11929 0 0 1.11929 0 2.5C0 3.70948 0.85888 4.71836 2 4.94999V12.5C2 12.7761 2.22386 13 2.5 13C2.77614 13 3 12.7761 3 12.5V4.94999Z"
        fill="black"
      />
    </svg>
  );
};

const TextIcon = ({ className, color, strokeWidth }: SvgIconProps) => {
  return (
    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.950781 0.949805L0.950781 2.49977C0.950781 2.74829 0.749309 2.94977 0.500781 2.94977C0.252253 2.94977 0.0507812 2.74829 0.0507812 2.49977V0.499824C0.0507812 0.45225 0.0581636 0.406401 0.0718451 0.363359C0.129631 0.181536 0.299826 0.0498047 0.500787 0.0498047H8.50079C8.65612 0.0498047 8.79307 0.128505 8.87393 0.248205C8.92246 0.320026 8.95079 0.406607 8.95079 0.499805L8.95079 0.499824V2.49977C8.95079 2.74829 8.74932 2.94977 8.50079 2.94977C8.25226 2.94977 8.05079 2.74829 8.05079 2.49977V0.949805H5.05079V10.0498H6.25513C6.50366 10.0498 6.70513 10.2513 6.70513 10.4998C6.70513 10.7483 6.50366 10.9498 6.25513 10.9498H2.75513C2.50661 10.9498 2.30513 10.7483 2.30513 10.4998C2.30513 10.2513 2.50661 10.0498 2.75513 10.0498H3.95079V0.949805H0.950781Z"
        fill="#191919"
      />
    </svg>
  );
};

const ImageIcon = ({ className, color, strokeWidth }: SvgIconProps) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 0H11.5C12.3284 0 13 0.671572 13 1.5V11.5C13 12.3284 12.3284 13 11.5 13H1.5C0.671574 13 0 12.3284 0 11.5V1.5C0 0.671574 0.671572 0 1.5 0ZM1.5 1C1.22386 1 1 1.22386 1 1.5V7.3636L2.6818 5.6818C2.76809 5.59551 2.88572 5.54797 3.00774 5.55007C3.12975 5.55216 3.24568 5.60372 3.32895 5.69293L6.87355 9.49005L9.6818 6.6818C9.85754 6.50607 10.1425 6.50607 10.3182 6.6818L12 8.3636V1.5C12 1.22386 11.7761 1 11.5 1H1.5ZM1 11.5V8.6364L2.98887 6.64753L6.5311 10.4421L7.94113 12H1.5C1.22386 12 1 11.7761 1 11.5ZM11.5 12H9.15503L7.48336 10.153L10 7.6364L12 9.6364V11.5C12 11.7761 11.7761 12 11.5 12ZM5.64922 4.5C5.64922 4.03013 6.03013 3.64922 6.5 3.64922C6.96987 3.64922 7.35078 4.03013 7.35078 4.5C7.35078 4.96987 6.96987 5.35078 6.5 5.35078C6.03013 5.35078 5.64922 4.96987 5.64922 4.5ZM6.5 2.74922C5.53307 2.74922 4.74922 3.53307 4.74922 4.5C4.74922 5.46693 5.53307 6.25078 6.5 6.25078C7.46693 6.25078 8.25078 5.46693 8.25078 4.5C8.25078 3.53307 7.46693 2.74922 6.5 2.74922Z"
        fill="black"
      />
    </svg>
  );
};

const StampIcon = ({ className, color, strokeWidth }: SvgIconProps) => {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.14705 0.48922C6.34231 0.293958 6.6589 0.293958 6.85416 0.48922L12.511 6.14607C12.7063 6.34134 12.7063 6.65792 12.511 6.85318L6.85416 12.51C6.6589 12.7053 6.34231 12.7053 6.14705 12.51L0.490197 6.85318C0.294934 6.65792 0.294935 6.34134 0.490197 6.14607L6.14705 0.48922ZM6.5006 1.54988L1.55086 6.49963L6.5006 11.4494L11.4504 6.49963L6.5006 1.54988Z"
        fill="black"
      />
    </svg>
  );
};

const ArrowIcon = ({ className, color, strokeWidth }: SvgIconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      strokeWidth={strokeWidth || '1'}
      stroke="black"
      aria-hidden="true"
    >
      <line x1="1.5" y1="12.5" x2="12.5" y2="1.5" />
      <line x1="12.5" y1="1.5" x2="6.5" y2="1.5" />
      <line x1="12.5" y1="1.5" x2="12.5" y2="7.5" />
    </svg>
  );
};

const CancelIcon = ({ className }: SvgIconPropsStroke) => {
  return (
    <svg viewBox="0 0 64 64" strokeWidth="3" className={className} aria-hidden="true">
      <line x1="8.06" y1="8.06" x2="55.41" y2="55.94" />
      <line x1="55.94" y1="8.06" x2="8.59" y2="55.94" />
    </svg>
  );
};

export { PolygonIcon, LineIcon, CircleIcon, MarkerIcon, TextIcon, ImageIcon, StampIcon, CancelIcon, ArrowIcon };
